export default {
  selfRouterList: [
    // '/404', // nginx代理未修改
    '/user/login', // 登录
    '/user/sign-up-form', // 登录
    '/autoSave', // 自动保存名片
    '/colleague/view', // 同事

    '/edm/list', // 所有营销邮件列表
    '/edm/edit', // 邮件编辑新增页面
    '/edm/confirm', // 邮件确认
    '/edm/preview', // 预览
    '/edm/detail', // 邮件信息（结果列表）
    '/edm/messagecontent', // 邮件内容
    '/edm/draft', // 邮件草稿
    '/edm/tpl', // 邮件模板
    '/edm/tpledit', // 邮件模板编辑新增页面
    '/edm/filter', // 收件人过滤
    '/edm/unsubscribe', // 退订
    '/edm/success', // 退订成功
    '/noPermission', // 没有权限

    '/site/terms', // 用户手册
    '/site/privacy', // 隐私政策
    '/site/childPrivacy', // 儿童隐私保护
    '/site/thirdParty', // 第三方服务协议
    // '/site/roledetail', // 角色详情 nginx代理未修改

    '/card/view', // 名片夹
    '/card/merge', // 合并名片
    '/card/help', // 帮助
    '/card/edit', // 名片编辑

    '/ai/view', // AI名片制作

    '/help_center_pc', // 帮助中心

    '/mobile/meetingGuide', // 会议名片引导页
    '/mobile/meetingCard', // 会议名片设置页

    '/tool/excel', // 工具箱-导出到excel
    '/tool/export', // 工具箱-导出到crm
    '/tool/googlecontact', // 工具箱-导出到Google通讯录
    '/tool/googlecontact/callback', // 工具箱-Google绑定回调页面
    '/tool/outlookcontact', // 工具箱-导出到outlook通讯录
    '/tool/outlookcontact/callback', // 工具箱-outlook绑定回调页面
    '/tool/import', // 工具箱-批量导入到excel
    '/tool/modifypwd', // 工具箱-修改密码
    '/tool/tag', // 工具箱-公司标签管理
    '/tool/recycle', // 工具箱-名片回收站
    '/tool/synchronize', // 工具箱-存入私人名片夹

    '/admin/accountinfo', // 管理-首页
    '/admin/permission', // 管理-权限设置
    '/admin/department', // 管理-部门设置
    '/admin/member', // 管理-员工管理
    '/admin/crm', // 管理-企业CRM配置
    '/admin/googlecontact', // 管理-Google通讯录配置
    '/admin/outlookcontact', // 管理-outlook通讯录配置
    '/admin/security', // 管理-安全设置
    '/admin/managecreator', // 管理-修改名片创建者
    '/admin/manageuser', // 管理-批量更新员工
    '/admin/createuser', // 管理-批量导入员工
    '/admin/managedevice', // 管理-批量新增或删除设备

    '/payment/price', // 商品列表页
    '/payment/buy', // 购买套餐
    '/payment/incrcard', // 增加精准识别
    '/payment/incruser', // 增加成员
    '/payment/renew', // 续费套餐
    '/payment/upgrade', // 升级套餐
    '/payment/success', // 支付成功
    '/payment/paynotify', // 支付成功回调地址(国外stripe支付)
    '/payment/paycancel', // 支付取消回调地址(国外stripe支付和国内支付都可能会跳)
    '/payment/login', // 订单中心手机验证
    '/payment/bill', // 订单中心(线下订单)订单支付
    '/payment/agreement', // 名片全能王企业版付费服务购买协议

    '/user-info-statement-ccb/list', // 个人信息收集清单-列表页
    '/user-info-statement-ccb/base-info', // 个人信息收集清单-用户基本信息
    '/user-info-statement-ccb/auth-info', // 个人信息收集清单-网络身份鉴权信息
    '/user-info-statement-ccb/edu-info', // 个人信息收集清单-用户工作信息
    '/user-info-statement-ccb/service-info', // 个人信息收集清单-用户数据和服务内容信息
    '/user-info-statement-ccb/contact-detail', // 个人信息收集清单-通讯录权限
    '/user-info-statement-ccb/device-info', // 个人信息收集清单-设备属性信息
    '/user-info-statement-ccb/device-detail', // 个人信息收集清单-当前设备信息

    '/note/view', // 商谈记录列表
    '/task/view', // 任务列表

    '/crm/callback', // crm回调地址

    '/message/center', // 消息-名片共享
    '/message/taskcenter', // 消息-任务协作
    '/message/applylist', // 消息-待加入的同事
    '/message/hrchange', // 消息-人事变更
    '/message/uploadcard' // 消息-名片上传
  ],
  selfRouterPrefix: ['/edm/'],

  appName: 'ccb', // 需要修改
  appVersion: '1.5.29', // 需要修改

  JP_CCB_MAIN_URL: 'https://www.wowtech.co.jp/', // 日语环境企业版首页概要链接
  JP_CCB_TERM_URL: 'https://www.camcard.jp/business/terms/', // 日语环境企业版首页用户协议链接
  JP_CCB_TERM2_URL: 'https://www.wowtech.co.jp/privacy.html', // 日语环境企业版首页用户协议2链接
  JP_CCB_CONTACT_URL: 'https://www.camcard.jp/business/contact/index.php', // 日语环境企业版首页联系我们链接
  JP_CCB_DOWNLOAD_URL: 'https://www.camcard.jp/business/download/', // 日语环境企业版首页下载链接

  // 付费相关
  PAYMENT: {
    PAY_PACKAGE_LEVEL_TRIAL: 1,
    PAY_PACKAGE_LEVEL_FREE: 2
  },

  CONTACTUS_EMAIL: 'vipsupport@intsig.com',
  CONTACTUS_COST_EMAIL: 'marketing@intsig.com',
  CONTACTUS_KR_EMAIL: 'vipsupport@intsig.com',
  CONTACTUS_JP_EMAIL: 'jpvipsupport@intsig.com',

  /** ********* 用户角色 ************ */
  USER_ROLE_NOMAL: 0,
  USER_ROLE_SUPER_ADMIN: 1,
  USER_ROLE_ADMIN: 2,
  USER_ROLE_READONLY: 3,

  COLLEAGUEVCF: 'colleaguevcf',
  COLLEAGUEJPG: 'colleaguejpg',

  // 付费相关
  INVITE_LEFT: 'ids_invitees',

  // 营销邮件发送状态 默认状态为 1
  EDM_SEND_STATE: {
    ready: 1, // 默认状态（未点发送前）
    sent_timing: 2, // 定时发送
    send: 3, // 已发送
    send_fail_limit: 4, // 发送失败,超限
    send_fail_reputation: 5, // 发送失败,信誉度不够
    send_ongoing: 6, // 发送中
    all: 7 // 点击发送后所有状态（包括2,3,4,5,6）
  },

  // 单封邮件发送状态
  EDM_MAIL_STATE: {
    not_sent: 1, // 未发送
    sent: 2, // 已发送
    received: 3, // 对方收到,发送成功
    opened: 4, // 对方收到且已打开邮件
    not_received: 5 // 对方未收到,发送失败
  },
  // 单封邮件错误类型
  EDM_MAIL_ERRNO: {
    success: 0,
    invalid_address: 1,
    deferred: 2,
    bounce: 3,
    dropped: 3,
    spam_report: 4,
    bounced_address: 5,
    spam_reporting_address: 6,
    spam_content: 7,
    others: 8,
    no_limit: 9 // 额度不足
  },
  EDM_TMP_KEY: {
    // 收件人公司
    RECIPIENT_CORPORATION: {
      value: '%RecipientCo%',
      label: 'edm_template_recipient_company'
    },
    // 收件人姓名
    RECIPIENT_NAME: {
      value: '%RecipientName%',
      label: 'edm_template_recipient_name'
    },
    // 收件人职位
    RECIPIENT_POSITION: {
      value: '%RecipientPos%',
      label: 'edm_template_recipient_position'
    },
    // 收件人部门
    RECIPIENT_DEPARTMENT: {
      value: '%RecipientDept%',
      label: 'edm_template_recipient_department'
    },
    // 收件人邮箱
    RECIPIENT_EMAIL: {
      value: '%RecipientEmail%',
      label: 'edm_template_recipient_address'
    },
    // 发件人姓名
    SENDER_NAME: {
      value: '%SenderName%',
      label: 'edm_template_sender_name'
    },
    // 发件人邮箱
    SENDER_EMAIL: {
      value: '%SenderEmail%',
      label: 'edm_template_sender_email'
    },
    // 名片创建者姓名
    CREATOR_NAME: {
      value: '%CreatorName%',
      label: 'edm_template_creator_name'
    },
    // 名片创建者邮箱
    CREATOR_EMAIL: {
      value: '%CreatorEmail%',
      label: 'edm_template_creator_address'
    },
    // 收件人除姓氏的名字
    RECIPIENT_FIRST_NAME: {
      value: '%RecipientFirstName%',
      label: 'edm_template_recipient_first_name'
    }
  },

  // 根据地区显示付费地址
  EDM_PAYMENT_CONTACT: {
    riben: {
      email: 'ccb.sales@kingsoft.jp',
      phone: '03‐4226‐8232'
    },
    hanguo: {
      email: 'vipsupport@intsig.com',
      phone: ''
    },
    zhongguo: {
      email: 'vipsupport@intsig.com',
      phone: '021-61515590'
    },
    meiguo: {
      email: 'vipsupport@intsig.com',
      phone: ''
    }
  },

  // 营销邮件黑名单类型
  EDM_BLACKLIST_TYPE: {
    blacklist: 1, // 黑名单
    unsubscribe: 2, // 退订
    send_fail: 3 // 发送失败
  },

  // 营销邮件过滤器类型
  EDM_FILTER_TYPE: {
    mail: 1, // 邮箱后缀
    company: 2 // 公司名
  },

  // im的类型
  IM_TYPE: {
    MSN: 'im_msn',
    QQ: 'im_qq',
    GTALK: 'im_gtalk',
    AIM: 'im_aim',
    YAHOO: 'im_yahoo',
    ICQ: 'im_icq',
    JABBER: 'im_jabber',
    SKYPE: 'im_skype',
    OTHER: 'im_other'
  },

  // sns的类型
  SNS_TYPE: {
    RENREN: 'sns_renren',
    WEIBO: 'sns_weibo',
    KAIXIN: 'sns_kaixin',
    WECHAT: 'sns_wechat',
    WRETCH: 'sns_wretch',
    MIXI: 'sns_mixi',
    GREE: 'sns_gree',
    CYWORLD: 'sns_cyworld',
    ME2DAY: 'sns_me2day',
    FACEBOOK: 'sns_facebook',
    TWITTER: 'sns_twitter',
    LINKEDIN: 'sns_linkedin',
    MYSPACE: 'sns_myspace',
    FLICKR: 'sns_flickr',
    BEBO: 'sns_bebo',
    ORKUT: 'sns_orkut',
    STUDIVZ: 'sns_studivz',
    XING: 'sns_xing',
    SKYROCK: 'sns_skyrock',
    TUENTI: 'sns_tuenti',
    NETLOG: 'sns_netlog',
    BADOO: 'sns_badoo',
    INSTAGRAM: 'sns_instagram',
    YOUTUBE: 'sns_youtube',
    TIKTOK: 'sns_tiktok',
    PINTEREST: 'sns_pinterest',
    GITHUB: 'sns_github',
    BEHANCE: 'sns_behance',
    OTHER: 'sns_other'
  },

  // 密码加密后缀
  REGISTER_PASSWORD_SUFFIX: '_IntSig',

  // CRM CODE LIST
  CRM_LIST: ['SALESFORCE', 'SUGAR', 'MS_CRM', 'GOOGLECONTACTS', 'SALESFORCE_SANDBOX', 'ORACLE'],

  // CRM FAILED TYPE
  CRM_FAILED_TYPE: {
    11: 'ERROR_STORAGE_LIMIT',
    5: 'ERROR_EMPTY_LASTNAME_COMPANY',
    18: 'ERROR_EMPTY_EMAIL',
    16: 'ERROR_UNKNOWN_EXCEPTION',
    17: 'ERROR_FIELD_MISSING',
    2: 'ERROR_EMPTY_LASTNAME',
    3: 'ERROR_EMPTY_COMPANY',
    21: 'edm_send_duplication',
    19: 'err_invalidemail'
  },

  EXPORT_TYPE_HAND: 0,
  EXPORT_TYPE_AUTO: 1,
  EXPORT_FIELD_LEADS: 0,
  EXPORT_FIELD_CONTACTS: 1,

  // 国家对应多语言
  COUNTRY_LANGUAGE: {
    CN: 'zh-cn',
    JP: 'ja-jp',
    KR: 'ko-kr',
    US: 'en-us',
    OS_OTHER: 'en-us'
  },

  // crm类型
  CRM_TYPE_MAP: {
    1: 'Salesforce',
    2: 'Sugar',
    3: 'Dynamics'
  },
  SUPPORT_LANG: {
    default: 'en-us',
    zhcn: 'zh-cn',
    zhtw: 'zh-tw',
    zhsg: 'zh-tw',
    zhhk: 'zh-tw',
    enus: 'en-us',
    jajp: 'ja-jp',
    kokr: 'ko-kr',
    zh: 'zh-cn',
    en: 'en-us',
    ja: 'ja-jp',
    ko: 'ko-kr',
    zhhans: 'zh-cn',
    zhhant: 'zh-tw'
  }
}
